import React from 'react';
import {
	defineMessages,
	useIntl,
} from 'react-intl';

import DonutPagesChart from '../components/DonutPagesChart';



const messages = defineMessages({
	missing: {
		id: 'ui.screen.pagesGraphs.content.missing',
	},
});



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
};



const HreflangLanguageChart: React.FC<Props> = (props) => {
	const {
		data,
	} = props;

	const intl = useIntl();

	const categories = [
		{
			value: 'missing',
			label: intl.formatMessage(messages.missing),
			color: '#8595A6',
		},
	];

	const filteredData = data.filter((item) => {
		return (
			item.value !== 'others'
			|| item.count > 0
		);
	});

	return (
		<DonutPagesChart
			categories={categories}
			data={filteredData}
			name="hreflang_language"
			percentageFactor={100}
			randomColors={[
				'#367be2',
				'#FE8719',
				'#FF5959',
			]}
		/>
	);
};



export default React.memo(HreflangLanguageChart);
